import 'promise-polyfill/src/polyfill'
import Vue from 'vue'
import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

new Vue({
    el: "#app",
    data: {
        onload: false,
        county_id: "",
        store_url: "",
        store: [],
        storeData: [],
    },
    mounted: function () {
        if (window.stores !== undefined) {
            this.store = window.stores;
        }
        this.county_id = window.county_id;
        this.storeData = [];
        this.store.forEach((item) => {
            if (parseInt(item.county_id) === parseInt(this.county_id)) {
                this.storeData.push(item);
            }
        });
        this.store_url = window.store_url;
    },
    methods: {
        changeStore: function () {
            this.store_url = "";
            this.storeData = [];
            this.store.forEach((item) => {
                if (parseInt(item.county_id) === parseInt(this.county_id)) {
                    this.storeData.push(item);
                }
            });
        },
        changeMenu: function () {
            if (this.store_url !== "") {
                window.location.href = this.store_url;
            }
        }
    }
});
